export const TOAST_SUCCESS_TIME = 3000;
export const TOAST_ERROR_TIME = 5000;
export const HELP_CENTER_LINK = 'https://help.playbookux.com/en/articles/3962771-deleting-my-account';
export const COMPANY_NAME_LENGTH = 60;
export const FIRST_NAME_LENGTH = 30;
export const LAST_NAME_LENGTH = 40;
